import { webLightTheme } from '@fluentui/react-components';
import type { Theme } from '@fluentui/react-components';

// ATA brand primary: a rich navy-teal blue used on ata.net
const ATA_BRAND_PRIMARY = '#006B8F'; // ATA teal-blue
const ATA_BRAND_PRIMARY_DARK = '#005070';
const ATA_BRAND_PRIMARY_LIGHT = '#0087B3';
const ATA_BRAND_PRIMARY_LIGHTER = '#E5F4F9';

const customLightTheme: Theme = {
  ...webLightTheme,
  // Brand ramp overrides (colorBrandBackground, etc.)
  colorBrandBackground: ATA_BRAND_PRIMARY,
  colorBrandBackgroundHover: ATA_BRAND_PRIMARY_DARK,
  colorBrandBackgroundPressed: ATA_BRAND_PRIMARY_DARK,
  colorBrandBackgroundSelected: ATA_BRAND_PRIMARY_LIGHT,
  colorBrandForeground1: ATA_BRAND_PRIMARY,
  colorBrandForeground2: ATA_BRAND_PRIMARY_DARK,
  colorBrandForegroundLink: ATA_BRAND_PRIMARY,
  colorBrandForegroundLinkHover: ATA_BRAND_PRIMARY_DARK,
  colorBrandForegroundLinkPressed: ATA_BRAND_PRIMARY_DARK,
  colorBrandForegroundLinkSelected: ATA_BRAND_PRIMARY,
  colorBrandStroke1: ATA_BRAND_PRIMARY,
  colorBrandStroke2: ATA_BRAND_PRIMARY_LIGHT,
  colorBrandStroke2Hover: ATA_BRAND_PRIMARY,
  colorBrandStroke2Pressed: ATA_BRAND_PRIMARY_DARK,
  colorBrandBackgroundStatic: ATA_BRAND_PRIMARY,
  colorCompoundBrandBackground: ATA_BRAND_PRIMARY,
  colorCompoundBrandBackgroundHover: ATA_BRAND_PRIMARY_DARK,
  colorCompoundBrandBackgroundPressed: ATA_BRAND_PRIMARY_DARK,
  colorCompoundBrandForeground1: ATA_BRAND_PRIMARY,
  colorCompoundBrandForeground1Hover: ATA_BRAND_PRIMARY_DARK,
  colorCompoundBrandForeground1Pressed: ATA_BRAND_PRIMARY_DARK,
  colorCompoundBrandStroke: ATA_BRAND_PRIMARY,
  colorCompoundBrandStrokeHover: ATA_BRAND_PRIMARY_DARK,
  colorCompoundBrandStrokePressed: ATA_BRAND_PRIMARY_DARK,
  colorSubtleBackgroundSelected: ATA_BRAND_PRIMARY_LIGHTER,
  colorSubtleBackgroundLightAlphaSelected: ATA_BRAND_PRIMARY_LIGHTER,
};

export const appTheme = customLightTheme;
